// @ts-nocheck

import { useEffect, useRef } from 'react';
import { css, etiColors, resetButtonStyle, mediaQueries } from '@eti/styles';
import Ban from './Ban';
import CheckMark from './CheckMark';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const wrapperStyles = css`
  align-items: center;
  display: flex;
  flex-direction: column;
  font-size: 0.625rem;
  justify-content: space-around;
  min-width: 100px;
  position: relative;

  &:not(:nth-last-of-type(1))::after {
    background-color: ${etiColors.white};
    content: '';
    height: 2px;
    left: 50%;
    margin: 0 16px;
    position: absolute;
    top: 10px;
    transform: translateY(-50%);
    width: 68px;
  }

  [dir='rtl'] &:not(:nth-last-of-type(1))::after {
    left: unset;
    right: 50%;
  }
`;
const hiddenButtonStyles = css`
  color: ${etiColors.white};
  cursor: pointer;
  font-size: 0.75rem;

  ${resetButtonStyle};

  @media ${mediaQueries.medium.up} {
    font-size: 0.875rem;
  }
`;
const circleWrapperStyles = animationDelay => css`
  border-radius: 50%;
  display: block;
  height: 20px;
  position: relative;
  width: 20px;

  & span,
  & svg {
    transition-delay: ${animationDelay * 0.5}s;
  }
`;
const circleStyles = css`
  background: none;
  border: 2px solid ${etiColors.white};
  border-radius: 50%;
  height: 100%;
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translate3d(-50%, -50%, 0);
  transition: background-color 0.5s;
  width: 100%;
`;
const labelStyles = css`
  color: ${etiColors.white};
  display: flex;
  justify-content: center;
  margin-top: 0.313rem;
  width: 100%;

  @media ${mediaQueries.medium.up} {
    margin-top: 0.625rem;
  }
`;
const StepIndicatorItem = _ref => {
  let {
    index,
    isNotAvailable,
    label,
    onClick,
    onItemSelected,
    isCurrent,
    isChecked,
    isVisited,
    stepAnimationDelay,
    segmentType,
    segmentLabel
  } = _ref;
  const stepIndicatorRef = useRef(null);
  useEffect(() => {
    if (isCurrent && stepIndicatorRef.current) {
      onItemSelected === null || onItemSelected === void 0 || onItemSelected(stepIndicatorRef.current.getBoundingClientRect());
    }
  }, [isCurrent, onItemSelected]);
  return /*#__PURE__*/_jsxs("div", {
    className: wrapperStyles,
    "data-testid": `seatMap-segment-${isNotAvailable ? 'unavailable' : 'available'}${segmentType ? `-type-${segmentType}` : ''}`,
    ref: stepIndicatorRef,
    children: [/*#__PURE__*/_jsx("button", {
      "aria-label": segmentLabel,
      className: hiddenButtonStyles,
      "data-testid": `seatMap-stepIndicatorItem-button-${index}`,
      onClick: onClick,
      type: "button",
      children: /*#__PURE__*/_jsxs("span", {
        className: circleWrapperStyles(stepAnimationDelay !== null && stepAnimationDelay !== void 0 ? stepAnimationDelay : 0),
        children: [/*#__PURE__*/_jsx("span", {
          className: circleStyles,
          "data-testid": "seatMap-stepIndicatorItem-Circle"
        }), isNotAvailable && /*#__PURE__*/_jsx(Ban, {}), isChecked && /*#__PURE__*/_jsx(CheckMark, {
          isVisited: isVisited,
          shouldHide: isCurrent
        })]
      })
    }), /*#__PURE__*/_jsx("span", {
      className: labelStyles,
      children: label
    })]
  });
};
export default StepIndicatorItem;
//# sourceMappingURL=StepIndicatorItem.js.map